import * as t from '../types';
import {DELETE_HOLIDAYS_REQUEST, GET_HOLIDAYS_REQUEST, GET_TUTOR_ONE_2_ONE_REQUEST} from "../types";

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function deleteHolidaysReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.DELETE_HOLIDAYS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.DELETE_HOLIDAYS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.DELETE_HOLIDAYS_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
